'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--LightBulb';

var EntypoLightBulb = function EntypoLightBulb(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7.186,19.172C7.975,19.682,8.887,20.027,10,20c1.111,0.027,2.025-0.318,2.814-0.828L12.797,17H7.203L7.186,19.172z M12.697,16c0-4.357,4.63-5.848,4.283-10.188C16.762,3.074,14.907,0.002,10,0.002c-4.907,0-6.762,3.072-6.981,5.811C2.672,10.152,7.303,11.643,7.303,16H12.697z M5,6c0.207-2.598,2.113-4,5-4c2.886,0,4.654,1.371,4.861,3.969c0.113,1.424-0.705,2.373-1.809,3.926C12.238,11.041,11.449,12.238,11,14H9c-0.449-1.762-1.238-2.959-2.053-4.106C5.844,8.342,4.886,7.424,5,6z' })
    );
};

exports.default = EntypoLightBulb;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo-icons/lib/entypo/LightBulb.js
// module id = 647
// module chunks = 168707334958949